import api from '@/lib/api';
import type { AdminPlanPricingRow } from '@/types/admin';

export async function fetchPlanPricing(): Promise<AdminPlanPricingRow[]> {
  const { data } = await api.get('/admin/plan-pricing');
  return data?.data ?? [];
}

export interface UpdatePlanPricingPayload {
  monthlyPriceCents: number;
  yearlyPriceCents: number;
  notifyUsers?: boolean;
  announcementMessage?: string;
}

export async function updatePlanPricing(
  plan: string,
  payload: UpdatePlanPricingPayload,
): Promise<AdminPlanPricingRow> {
  const { data } = await api.patch(`/admin/plan-pricing/${plan}`, payload);
  return data?.data;
}

export async function resetPlanPricing(plan: string): Promise<AdminPlanPricingRow> {
  const { data } = await api.post(`/admin/plan-pricing/${plan}/reset`);
  return data?.data;
}
